import ModelUtil from '@leverege/model-util';
import { ns } from '@leverege/i18n';
import ValueGlyphSymbolizer from "./ValueGlyphSymbolizer.js";
const TYPE = 'graph.glyph.text';
const {
  t
} = ns('ui-attributes-graphs.models.TextGlyphModel');
function create(extend) {
  return {
    type: TYPE,
    stroke: null,
    fontSize: 14,
    text: ValueGlyphSymbolizer.create()
  };
}
export default {
  TYPE,
  create,
  ...ModelUtil.createAllValue('stroke'),
  ...ModelUtil.createAllValue('fontSize'),
  ...ModelUtil.createAllValue('text'),
  get name() {
    return t('name');
  }
};